import { useListenKeyboard, useScrollLock } from "@imwebme/clay-hooks";
import { Portal } from "..";
import { ModalBody } from "./Modal.body";
import { ModalContainer } from "./Modal.container";
import { ModalFooter } from "./Modal.footer";
import { ModalHeader } from "./Modal.header";
import { ModalOverlay } from "./Modal.overlay";
import { ModalProvider } from "./Modal.providers";
import type { ModalProps } from "./Modal.types";

const Modal = ({
  closeOnEsc = true,
  setClose,
  isOpen,
  closeOnBackdrop,
  children,
  width,
  fullHeight,
}: ModalProps) => {
  useScrollLock({ enable: isOpen });

  useListenKeyboard({
    key: "Escape",
    handler: setClose,
    enable: closeOnEsc,
  });

  return isOpen ? (
    <Portal>
      <ModalProvider setClose={setClose}>
        <ModalOverlay closeOnBackdrop={closeOnBackdrop} setClose={setClose}>
          <ModalContainer width={width} fullHeight={fullHeight}>
            {children}
          </ModalContainer>
        </ModalOverlay>
      </ModalProvider>
    </Portal>
  ) : null;
};

const ModalNamespace = Object.assign(Modal, {
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter,
});

export { ModalNamespace as Modal };
